import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { fetchContactsStatusThunk } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/effects";
import {
    selectIsContactsStatusFetched,
    selectIsContactsVisible,
    selectIsContactsDisabledByCountry,
    selectLoadingContactStatus,
} from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

export const useIsContactsAvailable = () => {
    const dispatch = useDispatch();

    const isContactsStatusFetched = useSelector(selectIsContactsStatusFetched);
    const isContactsVisible = useSelector(selectIsContactsVisible);
    const isContactsDisabledByCountry = useSelector(selectIsContactsDisabledByCountry);
    const isLoadingContactStatus = useSelector(selectLoadingContactStatus);

    useEffect(() => {
        if (!isContactsStatusFetched) {
            void dispatch(fetchContactsStatusThunk());
        }
    }, []);

    return {
        isContactsVisible,
        isLoadingContactStatus,
        isContactsDisabledByCountry,
        isContactsStatusFetched,
    };
};
